var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUlyanovskenergoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 80,
    viewBox: "0 0 307 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_3328)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1032_3328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.37 50.048C56.5 50.048 55.56 49.868 54.52 49.578V45.408C55.08 45.608 55.75 45.718 56.36 45.718C57.21 45.718 57.88 45.498 58.17 44.818L58.42 44.328L52.46 33.998H57.99L60.86 40.158L63.17 33.998H68.68L63.03 46.078C61.69 48.988 59.96 50.048 57.36 50.048H57.37Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75 33.998V49.678H78.57V38.518H76.4C75.97 44.168 75.06 49.968 70.31 49.968C69.48 49.968 68.7 49.858 67.96 49.628V45.148C68.52 45.328 69.08 45.278 69.53 45.018C71.57 44.058 71.41 38.098 71.68 33.998H83.76H83.75Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.47 49.6878V34.0078H92.65V38.4878H94.33C97.94 38.4878 101.1 39.6778 101.1 44.0878C101.1 48.4978 97.94 49.6878 94.33 49.6878H87.47ZM92.65 45.4278H94.29C95.21 45.4278 95.99 45.0478 95.99 44.0878C95.99 43.1278 95.21 42.7478 94.29 42.7478H92.65V45.4378V45.4278Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.39 49.6878L106.38 44.1578C104.63 43.3078 103.51 41.8478 103.51 39.5878C103.51 35.4178 106.76 34.0078 110.19 34.0078H117.47V49.6878H112.32V45.0478H111.45L108.22 49.6878H102.39ZM110.48 41.1778H112.32V38.2178H110.48C109.32 38.2178 108.73 38.8278 108.73 39.6978C108.73 40.5678 109.31 41.1778 110.48 41.1778Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78 33.998V49.678H130.63V44.098H126.37V49.678H121.19V33.998H126.37V39.578H130.63V33.998H135.78Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34 33.6484C152.99 33.6484 155.83 37.3484 155.83 41.8484C155.83 46.3484 152.98 50.0484 147.34 50.0484C141.7 50.0484 138.85 46.3484 138.85 41.8484C138.85 37.3484 141.7 33.6484 147.34 33.6484ZM147.34 38.3284C145.32 38.3284 144.16 39.6984 144.16 41.8484C144.16 43.9984 145.32 45.3684 147.34 45.3684C149.36 45.3684 150.52 43.9984 150.52 41.8484C150.52 39.6984 149.35 38.3284 147.34 38.3284Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75 33.998C170.29 33.998 172.31 35.228 172.31 37.968C172.31 39.578 171.68 40.728 170.07 41.348C171.91 41.908 172.94 43.188 172.94 45.198C172.94 48.758 169.85 49.678 166.55 49.678H158.91V33.998H166.75ZM166.03 37.808H164.08V40.118L166.03 40.138C166.9 40.138 167.33 39.598 167.33 38.978C167.33 38.358 166.9 37.818 166.03 37.818V37.808ZM166.28 43.318H164.08V45.868H166.28C167.27 45.868 167.78 45.418 167.78 44.588C167.78 43.758 167.26 43.308 166.28 43.308V43.318Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87 33.6484C185.48 33.6484 187.1 33.9584 188.49 34.5884V39.2084C187.62 38.6084 186.18 38.1284 184.79 38.1284C182.64 38.1284 180.6 39.2084 180.6 42.0084C180.6 44.4784 182.62 45.5084 184.68 45.5084C186.29 45.5084 187.79 45.1084 188.6 44.3884V49.1184C187.21 49.7484 185.67 50.0584 184.01 50.0584C179.57 50.0584 175.29 47.7284 175.29 42.0184C175.27 36.0584 179.57 33.6584 183.87 33.6584V33.6484Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82 49.6878V34.0078H197V39.5678H198.3L201.44 34.0078H207.13L202.36 41.7878L207.22 49.6978H201.53L198.19 44.0978H197V49.6978H191.82V49.6878Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73 33.6484C218.03 33.6484 222.33 36.0484 222.31 42.0084C222.31 47.7184 218.03 50.0484 213.59 50.0484C212.04 50.0484 210.5 49.7384 209.11 49.1084V44.6484C209.98 45.3884 211.51 45.7484 213.01 45.7484C214.89 45.7484 216.51 45.3184 217.11 43.7984H211.37V39.8784H217.06C216.39 38.3284 214.84 37.9284 212.98 37.9084C211.57 37.9084 210.04 38.3384 209.1 38.9584V34.5884C210.49 33.9584 212.1 33.6484 213.72 33.6484H213.73Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.97 33.998V49.678H234.82V44.098H230.56V49.678H225.38V33.998H230.56V39.578H234.82V33.998H239.97Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57 33.998V38.078H248.87V39.898H254.76V43.708H248.87V45.568H255.7V49.688H243.69V34.008H255.57V33.998Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83 33.998C269.82 33.998 272.87 35.388 272.87 39.798C272.87 44.208 269.82 45.578 265.83 45.578H264.15V49.678H258.97V33.998H265.83ZM265.79 38.258H264.15V41.328H265.79C266.98 41.328 267.74 40.878 267.74 39.808C267.74 38.738 266.98 38.258 265.79 38.258Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8 49.6878V34.0078H287.56V38.5378H280.97V49.6978H275.79L275.8 49.6878Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72 33.6484C303.37 33.6484 306.21 37.3484 306.21 41.8484C306.21 46.3484 303.36 50.0484 297.72 50.0484C292.08 50.0484 289.23 46.3484 289.23 41.8484C289.23 37.3484 292.08 33.6484 297.72 33.6484ZM297.72 38.3284C295.7 38.3284 294.54 39.6984 294.54 41.8484C294.54 43.9984 295.7 45.3684 297.72 45.3684C299.74 45.3684 300.9 43.9984 300.9 41.8484C300.9 39.6984 299.73 38.3284 297.72 38.3284Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.81 27.5198L28.97 33.3598C30.23 35.1298 31 37.2698 31.08 39.5798H22.75L17.04 45.2898H29.8C27.89 48.9498 24.06 51.4498 19.65 51.4498C17.17 51.4498 14.89 50.6598 13.01 49.3198L7.17 55.1598C10.56 57.9498 14.91 59.6298 19.65 59.6298C30.5 59.6298 39.29 50.8398 39.29 39.9898C39.29 35.2498 37.61 30.8998 34.82 27.5098L34.81 27.5198Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22 34.8294L29.84 23.2094C26.87 21.3994 23.38 20.3594 19.64 20.3594C15.17 20.3594 11.06 21.8494 7.75999 24.3694L18.22 34.8294Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91 35.5001L2.99 29.5801C1.1 32.6001 0 36.1701 0 40.0001C0 43.8301 1.04 47.2201 2.85 50.2001L17.54 35.5001H8.9H8.91Z",
    fill: "#283581"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_3328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306.21,
    height: 80,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1032_3328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306.21,
    height: 39.28,
    fill: "white",
    transform: "translate(0 20.3594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlyanovskenergoLogo);
export default __webpack_public_path__ + "static/media/ulyanovskenergo_logo.4f8400689b6d7c512db3ac6a23c69910.svg";
export { ForwardRef as ReactComponent };